var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.0559C14.4182 18.0559 18 14.4742 18 10.0559C18 5.63763 14.4182 2.05591 10 2.05591C5.58172 2.05591 2 5.63763 2 10.0559C2 14.4742 5.58172 18.0559 10 18.0559Z",
    stroke: "#202D49",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4884 2.8479C13.4884 2.8479 14.6085 6.04789 9.96047 8.2879C5.31243 10.5279 14.2484 8.6079 13.9124 11.5599C13.6724 13.6079 10.8885 13.1599 10.4645 15.2239C10.5525 11.8799 10.0485 9.8559 8.26444 9.3999C6.48044 8.9439 3.81645 8.4159 6.27245 5.6479C7.87245 3.8079 4.78436 3.98388 4.78436 3.98388",
    stroke: "#202D49",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoIcon);
export default __webpack_public_path__ + "static/media/GeoIcon.a578803ddbb98990a988f7f0fdf65fb9.svg";
export { ForwardRef as ReactComponent };